import { Component, Input, ViewChild, Output, EventEmitter, ChangeDetectorRef, AfterViewInit, OnDestroy, ViewEncapsulation } from '@angular/core';

import * as uuid from 'uuid';
import { NgForm, NgModel } from '@angular/forms';

@Component({
  selector: 'sd-textarea-control',
  templateUrl: './textarea-control.component.html',
  styleUrls: ['../../assets/css/form.scss', './textarea-control.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class TextareaControlComponent implements AfterViewInit, OnDestroy {
  name = uuid.v4();

  @Input() form: NgForm;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() rows = 5;
  _model: any;
  @Input() set model(value: any) {
    this.ref.detectChanges();
    // setTimeout(() => {
    //     this._model = value;
    // }, 0);
    this._model = value;
  }

  @Output() modelChange = new EventEmitter();

  // Optional
  @Input() required: boolean;
  @Input() maxlength: number;
  @Input() pattern: string;
  @Input() disabled: boolean;

  @ViewChild('formModel') formModel: NgModel;
  constructor(private ref: ChangeDetectorRef) {
  }

  ngAfterViewInit() {
    if (this.form && this.formModel) {
      this.form.addControl(this.formModel);
    }
  }

  ngOnDestroy() {
    if (this.form && this.formModel) {
      this.form.removeControl(this.formModel);
    }
  }

  onChange(value: any) {
    this._model = value;
    this.modelChange.emit(this._model);
  }
}
